<sc-activity-list-item [activity]="activity" [condensed]="condensed" [showProjectName]="context == 'candidate'">
    <i scActivityIcon class="fa-sharp fa-solid fa-check"></i>
    @if (context != 'project') {
    {{ texts.referenceAcceptedShort[language] }}
    } @else {
    {{ texts.referenceAcceptedPrefix[language] }} <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> {{ texts.referenceAcceptedSuffix[language] }}
    }
</sc-activity-list-item>
